







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Label extends Vue {
    @Prop({}) title: string;
    @Prop({}) titleName: string;
}
